
import { Component, Prop, Vue } from "vue-property-decorator";
import * as _ from 'underscore';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form13";
const form13State = namespace("Form13");

import { documentInfoType } from "@/types/Information";
import { form13FormsJsonDataType } from "@/types/Information/Form13";

@Component
export default class TableForm13 extends Vue {

    @Prop({required: true})
    enableActions!: boolean;
    
    @form13State.State
    public form13FormsJson!: form13FormsJsonDataType[];
    
    @form13State.Action
    public UpdateCurrentConsentOrderExtendTimeId!: (newCurrentConsentOrderExtendTimeId: string) => void
    
    allDocumentsChecked = false;
    showSelectFormToFill = false;
    
    documentsList: documentInfoType[] = [];
  
    documentsFields = [
        {
            key:'select',          
            label:'',                  
            thClass: 'border-dark border-bottom',            
            sortable:false            
        },       
        {
            key: "fileNumber",
            label: "App #",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "description",
            label: "Document Description",
            sortable: false,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "caseNumber",
            label: "File #",
            sortable: false,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "parties",
            label: "Parties",
            sortable: false,
            thClass: 'border-dark border-bottom',
        },            
        {
            key: "status",
            label: "Status",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "modifiedDate",
            label: "Last Updated",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "packageNum",
            label: "eFiling #",
            sortable: true,
            thClass: 'border-dark border-bottom',
        },
        {
            key: "action",
            label: "Action",
            sortable: false,
            thClass: 'border-dark border-bottom',
        }
    ];

    confirmDelete = false;
    applicationsToDelete = [];
    applicationsNotAllowedToDelete = [];

    errorMsg = "";
    errorMsgDismissCountDown = 0;
   

    mounted() {        
        this.extractDocuments();       
    }

    public extractDocuments () {
    //TODO: when extending to use throughout the province, the timezone should be changed accordingly    
        this.documentsList = [];
        for (const docJson of this.form13FormsJson) {                
            const doc = {
                isChecked: false, 
                pdf_types:'', 
                fileNumber:0, 
                caseNumber:'', 
                parties:'', 
                appNames: '', 
                resNames: '', 
                status:'', 
                modifiedDate:'', 
                packageNum:'',
                packageUrl:'',
                description:[]
            };
            //console.log(docJson)
            doc.fileNumber = docJson.id;
            doc.caseNumber = docJson.data.formSevenNumber;
            doc.status = docJson.archive? "Archived":docJson.status;
            doc.modifiedDate = docJson.modified;
            doc.pdf_types = docJson.pdf_types;
            doc.description = [docJson.description];
            doc.packageUrl = docJson.packageUrl;
            doc.packageNum = docJson.packageNumber;

            const appellants = docJson.data.appellants;
            const respondents = docJson.data.respondents;
            const app_names = [];
            const res_names = [];
            for (const app of appellants){
                app_names.push(app.name)                
            }
            for (const res of respondents){
                res_names.push(res.name)                
            }
            doc.appNames = app_names.join(', ')
            doc.resNames = res_names.join(', ');

            this.documentsList.push(doc);
        }
        
        if(!this.enableActions && this.documentsList.length>2){            
            this.documentsList = _.sortBy(this.documentsList, 'modifiedDate').reverse().splice(0,2)
        }   
    }

    public resumeApplication(fileInfo: documentInfoType) {
        const caseId = fileInfo.fileNumber.toString()
        this.UpdateCurrentConsentOrderExtendTimeId(caseId);             
        this.$router.push({name: "fill-form13"});       
    }

    public createDocument() {
        this.$router.push({name: "checklist-orders" });
    }

    public downloadDocument(fileNumber?) {
        const checkedFileIdsList = this.documentsList.filter(doc => {return doc.isChecked}).map(doc => doc.fileNumber)

        if(fileNumber || checkedFileIdsList.length>0){
            
            const filenum = fileNumber? fileNumber: '0';
            const pdf_filename = fileNumber? "Form.pdf":"Form.zip";

            let pdfIds = ''
            for(const fileId of checkedFileIdsList)
                pdfIds+= '&id='+fileId;

            if(fileNumber) pdfIds = ''

            const pdf_type = 'FORM';
            const url = '/form13/form-print/'+filenum+'/?pdf_type='+pdf_type+pdfIds;
            const options = {
                responseType: "blob",
                headers: {
                "Content-Type": "application/json",
                }
            }
            this.$http.get(url, options)
            .then(res => {
                const blob = res.data;
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.download = pdf_filename;
                link.click();
                setTimeout(() => URL.revokeObjectURL(link.href), 1000);
            },err => {
                          
                this.errorMsg = "PDF file has not been generated for the selected documents !"
                this.errorMsgDismissCountDown = 5;                
            });
        }
    }

    public navigateToEFilingHub(package_url) {
        window.open(package_url)
    }

    public deleteDocument() {

        this.applicationsToDelete = this.documentsList.filter(doc => {return (doc.isChecked && doc.status !='Submitted')}).map(doc => doc.fileNumber)
        this.applicationsNotAllowedToDelete = this.documentsList.filter(doc => {return (doc.isChecked && doc.status =='Submitted')}).map(doc => doc.fileNumber)

        if(this.applicationsToDelete.length>0 || this.applicationsNotAllowedToDelete.length>0){
            this.confirmDelete=true;            
        }
    } 
    
    public confirmDeleteApplication() { 
        const data ={
            data:{
                ids:this.applicationsToDelete
            }
        }

        const url = '/form13/forms';

        this.$http.delete(url, data)
        .then(response => {
            
            if(response?.status == 204)
                this.$emit('reload')

        }, err => {
            this.errorMsg = "Error while Deleting !"
            this.errorMsgDismissCountDown = 2;
        })
        
        this.confirmDelete=false;

    }

    public checkAllDocuments(checked){
        for(const docInx in this.documentsList) {       
            this.documentsList[docInx].isChecked = checked;              
        }        
    }

    public toggleSelectedDocuments() {  
        Vue.nextTick(()=>{

            const checkedDocs = this.documentsList.filter(document=>{return document.isChecked});
            
            if(checkedDocs.length == this.documentsList.length)
                this.allDocumentsChecked = true;
            else
                this.allDocumentsChecked = false;                       
        })        
	}

    public errorMsgCountDownChanged(dismissCountDown){
        this.errorMsgDismissCountDown = dismissCountDown
    }
}
